export default [
  {
    path: '/admin/explore/list',
    name: 'exploreList',
    component: () => import('@/views/admin/explore/list.vue'),
    meta: { title: '灵感', requireAuth: true }
  }
]
